import { FeeAccountIcon } from '@infinex/ui-icons';
import { cn } from '@infinex/ui-styles';

import { getCustodyIcon, type CustodyIconType } from '../../utils/custodyIcon';
import { CustodyEmblemFromWalletId } from '../custody';

export const TransactionDetailRowsSection = ({
  children,
  highlightOdd = false,
}: {
  children: React.ReactNode;
  highlightOdd?: boolean;
}) => {
  return (
    <div
      className={cn('flex flex-col', {
        '[&>*:nth-child(even)]:bg-surface': !highlightOdd,
        '[&>*:nth-child(odd)]:bg-surface': highlightOdd,
      })}
    >
      {children}
    </div>
  );
};
/**
 * Generic row component for displaying transaction details.
 * Used in review screens and processing states.
 */
export const TransactionDetailRow = (props: {
  label: React.ReactNode;
  value: React.ReactNode;
  shaded?: boolean;
  className?: string;
  /** Overrides the default right-aligned value column styles. */
  valueClassName?: string;
}) => {
  return (
    <div
      className={cn(
        'flex justify-between gap-3 rounded-md px-4 py-2 text-sm',
        {
          'bg-surface': props.shaded,
        },
        props.className
      )}
    >
      <div className="text-secondary flex min-w-30 shrink-0 items-center gap-1.5 text-sm">
        {props.label}
      </div>

      <div
        className={cn(
          'text-secondary flex min-w-0 flex-col gap-1 text-right text-sm font-semibold text-wrap break-all',
          props.valueClassName
        )}
      >
        {props.value}
      </div>
    </div>
  );
};

/**
 * Displays a fee account row with icon. TODO: Bob check if this is still needed
 */
export const FeeAccountRow = () => {
  return (
    <div className="flex items-center gap-x-1">
      <FeeAccountIcon size="2xsmall" fill="default" />
      <div className="text-emphasis font-semibold">Gas Account</div>
    </div>
  );
};

/**
 * Displays a wallet/custody row with dynamic icon and name.
 */
export const WalletRow = ({
  wallet,
  custodyIconType,
  walletId,
}: {
  wallet: string;
  custodyIconType: CustodyIconType;
  walletId?: string;
}) => {
  const Icon = getCustodyIcon(custodyIconType);
  return (
    <div className="flex items-center gap-x-1">
      {walletId ? (
        <CustodyEmblemFromWalletId
          walletId={walletId}
          size="small"
          withoutBackground
        />
      ) : (
        <Icon size="2xsmall" className="fill-brand" />
      )}
      <div className="text-emphasis max-w-56 truncate font-semibold">
        {wallet}
      </div>
    </div>
  );
};
